var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useState } from 'react';
import { INPUT_TYPE, StyleType } from "../utils/variables";
import TextField from "../inputTextField";
import Button from "../button";
import "./style.scss";
var DateType;
(function (DateType) {
    DateType["fromDate"] = "fromDate";
    DateType["toDate"] = "toDate";
})(DateType || (DateType = {}));
;
var dateToString = function (timestamp) {
    var date = new Date(timestamp);
    var day = ("0" + date.getDate()).slice(-2);
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    return "".concat(date.getFullYear(), "-").concat(month, "-").concat(day);
};
var defaultMinMaxDate = function (dateMinMax) { return (__assign(__assign({}, ((dateMinMax === null || dateMinMax === void 0 ? void 0 : dateMinMax.min) && { min: dateToString(dateMinMax.min) })), ((dateMinMax === null || dateMinMax === void 0 ? void 0 : dateMinMax.max) && { max: dateToString(dateMinMax.max) }))); };
var DateRangePicker = function (props) {
    var fromDateMax = { max: dateToString(Date.now()) };
    var toDateMin = __assign({ min: dateToString(props.defaultFromDateInMillSec) }, fromDateMax);
    var _a = useState(new Date(props.defaultToDateInMillSec)), toDate = _a[0], updateToDate = _a[1];
    var _b = useState(new Date(props.defaultFromDateInMillSec)), fromDate = _b[0], updateFromDate = _b[1];
    var _c = useState(__assign(__assign({}, toDateMin), defaultMinMaxDate(props.toDateMinMax))), toMinMax = _c[0], updateToMinMax = _c[1];
    var _d = useState(__assign(__assign({}, fromDateMax), defaultMinMaxDate(props.fromDateMinMax))), fromMinMax = _d[0], updateFromMinMax = _d[1];
    var _e = useState(props.errorMsg ? props.errorMsg : null), error = _e[0], setError = _e[1];
    var handleButtonClick = function () {
        if (props.allowedRangeInDays) {
            var oneDayInMilliSec = 1000 * 60 * 60 * 24 * 1;
            var daysDiff = (toDate.getTime() - fromDate.getTime()) / oneDayInMilliSec;
            if (Math.floor(daysDiff) > props.allowedRangeInDays) {
                setError("Range should be within ".concat(props.allowedRangeInDays, "days"));
                return;
            }
        }
        props.onClick(fromDate, toDate);
    };
    var handleDateChange = function (fieldName, date) {
        setError(null);
        var dt = new Date(date);
        if (fieldName === DateType.fromDate) {
            updateFromDate(new Date(dt.setHours(0, 0, 0, 0)));
            updateToMinMax(function (state) { return (__assign(__assign({}, state), { min: dateToString(dt) })); });
        }
        else {
            updateToDate(new Date(dt.setHours(23, 59, 59, 999)));
            updateFromMinMax(function (state) { return (__assign(__assign({}, state), { max: dateToString(dt) })); });
        }
    };
    return (React.createElement("div", { className: "date-range-picker-container" },
        React.createElement("div", { className: "date-range-picker" },
            React.createElement(TextField, __assign({ type: INPUT_TYPE.DATE, placeholder: 'Select From Date', value: dateToString(fromDate.getTime()), fieldName: DateType.fromDate, onChange: function (fieldName, val) { return handleDateChange(fieldName, val); }, styleType: StyleType.borderBottomInput }, fromMinMax)),
            React.createElement(TextField, __assign({ type: INPUT_TYPE.DATE, placeholder: 'Select To Date', value: dateToString(toDate.getTime()), fieldName: DateType.toDate, onChange: function (fieldName, val) { return handleDateChange(fieldName, val); }, styleType: StyleType.borderBottomInput }, toMinMax)),
            React.createElement(Button, { buttonText: props.buttonText ? props.buttonText : "Load", onClick: function () { return handleButtonClick(); }, maxWidth: 150, height: 40, width: "100%" })),
        !!error &&
            React.createElement("div", { className: "error-message" }, error)));
};
export default DateRangePicker;
//# sourceMappingURL=index.js.map